module.exports = __webpack_public_path__ + "img/Unsign.a9375ad8.svg";